import { OFFER_KIND } from '../../../../../../views/menu/offers/constants';

export default {
  title: 'Opret nyt tilbud',
  subtitle: 'Hvordan får kunden en gratis vare?',
  validation: {
    required: 'Vælg en tilbudstype',
  },
  types: {
    [OFFER_KIND.PERCENTAGE_OFF_BY_MIN_SPEND_VALUE]: {
      name: 'Samlet ordreværdi',
      description: 'F.eks. 10 % rabat på din ordre, når du bruger 20 {{currency}}',
    },
    [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: {
      name: 'Udvalgte varer',
      description: 'F.eks. 10 % rabat på 12-tommers pizzaer.',
    },
    [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: {
      name: 'Udvalgte varer',
      description: 'F.eks. 1 {{currency}} rabat på 12-tommers pizzaer.',
    },
    [OFFER_KIND.AMOUNT_OFF_BY_MIN_SPEND_VALUE]: {
      name: 'Samlet ordreværdi',
      description: 'F.eks. 1 {{currency}} rabat på din ordre, når du bruger 20 {{currency}}',
    },
    [OFFER_KIND.BOGO]: {
      name: 'Køb 1, få 1 gratis',
      description: 'F.eks. køb 1 pizza og få en pizza til gratis. Den billigste pizza er rabatteret.',
    },
    [OFFER_KIND.BOGO_HALF_PRICE]: {
      name: 'Køb 1, få 1 til halv pris',
      description: 'F.eks. køb 1 pizza og få en pizza til halv pris. Den billigste pizza er rabatteret.',
    },
    [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: {
      name: 'Ved køb af en anden vare',
      description: 'F.eks. få en gratis drik, når du bestiller et måltid.',
    },
    [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: {
      name: 'Ved at bruge et fast beløb i {{currency}}',
      description: 'F.eks. få en gratis dessert, når du bruger 20 {{currency}}.',
    },
  },
};
